import axios, { sendRequest } from "../axios";
export default {
  state: {
    MT: [],
    BT: [],
    KT: [],
    ratesFactor: [],
    currentProductIDCS: null
  },
  mutations: {
    SET_CURRENT_PRODUCT_IDCS(state, commit) {
      state.currentProductIDCS = commit;
    },
    SET_MT(state, commit) {
      state.MT = commit;
    },
    SET_BT(state, commit) {
      state.BT = commit;
    },
    SET_KT(state, commit) {
      state.KT = commit;
    },
    SET_RATESFACTORS(state, commit) {
      state.ratesFactor = commit;
    }
  },
  actions: {
    GetCalcTariffSettingsCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        commit("SET_CURRENT_PRODUCT_IDCS", data);
        sendRequest("api/getAllT/" + data, "post", undefined, reject).then(
          response => {
            commit("SET_KT", response.data.koeff);
            commit("SET_MT", response.data.mt);
            commit("SET_BT", response.data.bt);
            commit("SET_RATESFACTORS", response.data.ratesFactor);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    clearTariffsAndGetNewDataCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/clearTariffsAndGetNewData", "post", data).then(
          response => {
            commit("SET_KT", response.data.koeff);
            commit("SET_MT", response.data.mt);
            commit("SET_BT", response.data.bt);
            commit("SET_RATESFACTORS", response.data.ratesFactor);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    clearTariff({ commit }, data){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/clearTariffs", "post", data,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    loadTariffsCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        const config = { "content-type": "multipart/form-data" };
        commit("SET_PROCESSING", true);
        sendRequest("api/loadTariffs",'post',data,undefined, config).then(response => {
          commit("SET_KT", response.data.koeff);
          commit("SET_MT", response.data.mt);
          commit("SET_BT", response.data.bt);
          commit("SET_RATESFACTORS", response.data.ratesFactor);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    updateMT({commit},data){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateMT/" + 1, "post", data,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateBT({commit},data){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateBT/" + 1, "post", data,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateKoeff({commit},data){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateKoeff/" + 1, "post", data,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getAllT({commit},id){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getAllT/" + id, "post", undefined,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getKoeff({commit},id){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getKoeff/" + id, "post", undefined,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getMT({commit},id){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getMT/" + id, "post", undefined,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getBT({commit},id){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getBT/" + id, "post", undefined,reject).then(
          response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },

  },
  getters: {
    getCurrentProductIDCS: state => state.currentProductIDCS,
    getMT: state => state.MT,
    getBT: state => state.BT,
    getKT: state => state.KT,
    getratesFactor: state => state.ratesFactor,
    getratesFactorById: state => id => {
      return state.ratesFactor.filter(item => item.id === id);
    }
  }
};
